export function removeAllChildNodes(parent) {
    while (parent.firstChild) {
        parent.removeChild(parent.firstChild);
    }
}

export function objIsEmpty(obj) {
  // because Object.keys(new Date()).length === 0;
  // we have to do some additional check
  return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
}

export function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export const formToJsonObj = (form) => {
  const formObj = {};
  const elements = form.querySelectorAll("input, select, textarea");
  for (const el of elements) {
    if (el.type == "submit") {
      continue
    }
    const name = el.name;
    if (name) {
      if (el.type == "checkbox") {
        formObj[name] = el.checked;
      } else {
        formObj[name] = el.value;
      }
    }
  }
  return formObj;
}

export const formToJson = (form, recaptcha_token=null) => {
  let data = null;
  const formObj = {};
  const elements = form.querySelectorAll("input, select, textarea");
  let multipart = false;
  for (const el of elements) {
    if (el.type == "submit") {
      continue
    }
    if (el.type == "file") {
      if (el.files.length == 0) {
        continue;
      }
      if (data === null) {
        data = new FormData();
      }
      data.append('file', el.files[0]);
      multipart = true;
    } else {
      const name = el.name;
      if (name) {
        if (el.type == "checkbox") {
          formObj[name] = el.checked;
        } else {
          formObj[name] = el.value;
        }
      }
    }
  }
  if (recaptcha_token !== null) {
    formObj.recaptcha_token = recaptcha_token;
  }
  if (!objIsEmpty(formObj)) {
    if (multipart) {
      data.append('data', JSON.stringify(formObj));
    } else {
      data = JSON.stringify({data: JSON.stringify(formObj)});
    }
  }
  return {data, multipart};
}

export function debounce(func, threshold=250, execAsap=false) {
  var timeout;
  return function debounced() {
    var obj = this,
        args = arguments;

    function delayed() {
      if (!execAsap) {
        func.apply(obj, args);
      }
      timeout = null;
    }
    if (timeout) {
      clearTimeout(timeout);
    } else if (execAsap) {
      func.apply(obj, args);
    }
    timeout = setTimeout(delayed, threshold || 100);
  };
}

function timeout (msTimeout, promise) {
  let timedOut = false

  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      timedOut = true
      reject(new Error("Timeout"))
    }, msTimeout)
    promise.then(
      (res) => {
        clearTimeout(timeoutId)
        if (!timedOut) {
          resolve(res)
        }
      },
      (err) => {
        clearTimeout(timeoutId)
        if (timedOut) { // already rejected on setTimeout
          return
        }
        reject(err)
      }
    )
  })
}

export async function fetch$ (url, options = {}, msTimeout = 10000, multiPart = false) {
  let controller, signal;

  try {
    controller = new AbortController();
    signal = { signal: controller.signal };
  } catch (error) {
    controller = null;
    signal = undefined;
  }

  let fixedOptions = {};
  if (!multiPart) {
    fixedOptions = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  }

  const finalOptions = Object.assign({}, fixedOptions, signal, options);

  let response = null;

  try {
    response = await timeout(msTimeout, fetch(url, finalOptions));
  } catch (e) {
    if (controller !== null) {
      controller.abort();
    }
    let status_code;
    if (e.message === 'Timeout') {
      status_code = 504;
    } else {
      status_code = 500;
    }
    const error = new Error(e.message);
    error.status = status_code;
    throw error;
  }

  if (response !== null && response.ok) {
    return await response.json();
  } else {
    const message = await response.text();
    const error = new Error(message);
    error.response = response;
    error.status = response.status;
    throw error;
  }

}

export const fadeIn = (el, ms, callback) => {
  ms = ms || 400;
  const finishFadeIn = () => {
    el.removeEventListener('transitionend', finishFadeIn);
    callback && callback();
  };
  el.style.transition = 'opacity 0s';
  el.style.display = '';
  el.style.opacity = 0;
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      el.addEventListener('transitionend', finishFadeIn);
      el.style.transition = `opacity ${ms/1000}s`;
      el.style.opacity = 1
    });
  });
};

export const fadeOut = (el, ms, callback) => {
  ms = ms || 400;
  const finishFadeOut = () => {
    el.style.display = 'none';
    el.removeEventListener('transitionend', finishFadeOut);
    callback && callback();
  };
  el.style.transition = 'opacity 0s';
  el.style.opacity = 1;
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      el.style.transition = `opacity ${ms/1000}s`;
      el.addEventListener('transitionend', finishFadeOut);
      el.style.opacity = 0;
    });
  });
};
